import fwUtil from 'framework-util'
export const generalStrategyService=new fwUtil.ApiService.ApiService('generalStrategy');




// WEBPACK FOOTER //
// ./src/api/generator/generator/generalStrategy.js